import React, { Component, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

import { Information } from '../components/modals/common';
import { MasterPageHeader } from '../components/PageHeader';
import { Description } from '../components/Description';
import {
  HeaderMenu,
  RowHeader,
  InputCheckBox,
  ToolTip,
} from '../components/ProgressBase';
import ProgressTemplateSelector from '../components/dropdowns/multi/ProgressTemplateSelector';
import { ProgressConfirmDialog } from '../components/modals/ProgressConfirmDialog';
import {
  HEADER_CONSTANTS_PROGRESS,
  TITLE_BROWSER_PROGRESS,
  REQUEST_PARAMS,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { setMaxHeightTable } from '../utilities/constWijmo';
import ProgressService from '../services/Progress';
import SessionStorageService from '../services/utilities/SessionStorageService';
import IconProgress from '../images/icon-progress.svg';

export class ProgressSelectWorkType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleDialogName: null,
      listMainWorkTypes: [],
      mainWorkId: null,
      defaultTemplateIds: [],
      allUsedTemplateIds: [],
      tempAllUsedTemplateIds: [],
      params: {
        delete_main_work_type_ids: [],
        add_main_work_type_ids: [],
        delete_sub_work_type_ids: [],
        add_sub_work_type_ids: [],
      },
      listWorkDelete: [],
      isShowConfirmDialog: false,
      isShowPopupError: false,
      isShowDialogUpdate: false,
      messageError: '',
    };

    this.fieldId = SessionStorageService.getFieldId();
    this.rootListMainWorkTypes = [];
    this.isInitData = true;
    this.isSubmitingFlag = false;
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
  }

  componentDidMount() {
    if (!this.isProgressFlg) {
      return window.location.replace('/error-permission');
    }
    const divFixed = document.querySelector('.fixed-scroller-header');
    if (divFixed) {
      const params = {
        heightOfTable: 'calc(100vh - 85px)',
        heightOfTableHaveNoti: 'calc(100vh - 125px)',
        heghtOfTableIpad: 'calc(100vh - 180px)',
        heightOfTableIpadHaveNoti: 'calc(100vh - 220px)',
      };
      setMaxHeightTable(divFixed, params);
    }
  }

  getListMainWorkTypes = async (ids, deleteIds = []) => {
    const response = await ProgressService.getProgressListMainWorkTypes(
      this.fieldId,
      {
        include_sub_work_types_flag: 1,
        work_type_template_ids: ids,
      }
    );
    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = false;
    }
    if (response.result) {
      const mainWorkTypes = _.get(response.data, 'entities.main_work_types');
      if (this.isInitData) {
        this.setState({
          listMainWorkTypes: mainWorkTypes,
        });
        this.rootListMainWorkTypes = mainWorkTypes;
        this.isInitData = false;
      } else {
        this.setState(prevState => ({
          listMainWorkTypes: [
            ..._.filter(prevState.listMainWorkTypes, item => {
              return !_.includes(deleteIds, `${item.template.id}`);
            }),
            ..._.map(mainWorkTypes, mainWork => {
              const {
                work_registered_flag,
                using_flag,
                sub_work_types,
              } = mainWork;
              return {
                ...mainWork,
                using_flag: work_registered_flag ? using_flag : false,
                sub_work_types: _.map(sub_work_types, subWork => {
                  return {
                    ...subWork,
                    using_flag: subWork.work_registered_flag,
                  };
                }),
              };
            }),
          ],
          defaultTemplateIds: prevState.allUsedTemplateIds,
        }));
      }
    }
  };

  updateFieldWorkTypes = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await ProgressService.updateProgressFieldWorkTypes(
      this.fieldId,
      this.state.params
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      this.setState({
        isShowConfirmDialog: false,
        isShowPopupError: false,
        isShowDialogUpdate: true,
      });
    } else {
      const message =
        _.get(response, 'data.message') ||
        messageUtility.getMessage('E-000-001');
      this.setState({
        isShowConfirmDialog: false,
        isShowPopupError: true,
        messageError: message,
      });
    }
  };

  getDefaultTemplateIds = values => {
    const defaultTemplateIds = _.map(
      _.filter(values, value => {
        return value.using_flag === true;
      }),
      item => {
        return `${item.id}`;
      }
    );
    const usedTemplateIds = _.isEmpty(defaultTemplateIds) ? [''] : defaultTemplateIds;
    this.setState(
      {
        defaultTemplateIds,
        allUsedTemplateIds: usedTemplateIds,
        tempAllUsedTemplateIds: usedTemplateIds,
      },
      () => this.getListMainWorkTypes(this.state.allUsedTemplateIds)
    );
  };

  setMainWorkId = id => {
    this.setState(
      {
        mainWorkId: id,
      },
      () => this.handleVisibleDialog('visibleDialogName', true)
    );
  };

  setTemplateIds = id => {
    this.setState({ tempAllUsedTemplateIds: id });
  };

  selectMainWork = (mainWorkId, workRegisteredFlag) => {
    if (workRegisteredFlag) {
      return;
    }
    this.setState(prevState => ({
      listMainWorkTypes: _.map(prevState.listMainWorkTypes, mainWork => {
        const { id, using_flag } = mainWork;
        return id !== mainWorkId
          ? mainWork
          : {
              ...mainWork,
              using_flag: !using_flag,
              sub_work_types: _.map(mainWork.sub_work_types, subWork => {
                return using_flag !== true
                  ? subWork
                  : { ...subWork, using_flag: false };
              }),
            };
      }),
    }));
  };

  selectSubWork = (subWorkId, mainWorkId, workRegisteredFlag) => {
    if (workRegisteredFlag) {
      return;
    }
    this.setState(prevState => ({
      listMainWorkTypes: _.map(prevState.listMainWorkTypes, mainWork => {
        return mainWork.id !== mainWorkId
          ? mainWork
          : {
              ...mainWork,
              sub_work_types: _.map(mainWork.sub_work_types, subWork => {
                const { id, using_flag } = subWork;
                return id !== subWorkId
                  ? subWork
                  : { ...subWork, using_flag: !using_flag };
              }),
            };
      }),
    }));
  };

  handleListWorkDelete = (listWorkDelete, rootMainWork, subWork = null) => {
    if (subWork) {
      return [
        ...listWorkDelete,
        `${rootMainWork.name} - ${subWork.name}（${
          rootMainWork.template.name
        }）`,
      ];
    }
    return [
      ...listWorkDelete,
      `${rootMainWork.name} - （${rootMainWork.template.name}）`,
    ];
  };

  handleGetParams = (params, key, value) => {
    if (!_.isArray(value)) {
      value = [value];
    }
    return {
      ...params,
      [key]: [...params[key], ...value],
    };
  };

  handleParam = () => {
    const { listMainWorkTypes } = this.state;
    let params = {
      delete_main_work_type_ids: [],
      add_main_work_type_ids: [],
      delete_sub_work_type_ids: [],
      add_sub_work_type_ids: [],
    };
    let listMainWorkRoot = [];
    let listMainWorkAddNew = [];
    const rootMainWorkIds = _.map(
      this.rootListMainWorkTypes,
      mainWork => mainWork.id
    );
    let listWorkDelete = [];

    _.forEach(listMainWorkTypes, mainWork => {
      if (rootMainWorkIds.includes(mainWork.id)) {
        listMainWorkRoot = [...listMainWorkRoot, mainWork];
      } else {
        listMainWorkAddNew = [...listMainWorkAddNew, mainWork];
      }
    });
    const mainWorkTypesObj = _.mapValues(_.keyBy(listMainWorkRoot, 'id'));

    if (!_.isEmpty(this.rootListMainWorkTypes)) {
      _.forEach(this.rootListMainWorkTypes, rootMainWork => {
        const mainWork = mainWorkTypesObj[rootMainWork.id];
        if (!mainWork) {
          if (rootMainWork.using_flag) {
            const subWorkUsed = _.without(
              _.map(rootMainWork.sub_work_types, subWork => {
                const isDelete = subWork.using_flag && subWork.id;
                if (isDelete) {
                  listWorkDelete = this.handleListWorkDelete(
                    listWorkDelete,
                    rootMainWork,
                    subWork
                  );
                }
                return isDelete;
              }),
              false
            );
            params = this.handleGetParams(
              params,
              'delete_main_work_type_ids',
              rootMainWork.id
            );
            if (_.isEmpty(subWorkUsed)) {
              listWorkDelete = this.handleListWorkDelete(
                listWorkDelete,
                rootMainWork
              );
            }
            params = this.handleGetParams(
              params,
              'delete_sub_work_type_ids',
              subWorkUsed
            );
          }
          return;
        }
        if (rootMainWork.using_flag !== mainWork.using_flag) {
          if (mainWork.using_flag) {
            const subWorkAddNew = _.without(
              _.map(
                mainWork.sub_work_types,
                subWork => subWork.using_flag && subWork.id
              ),
              false
            );
            params = this.handleGetParams(
              params,
              'add_main_work_type_ids',
              mainWork.id
            );
            params = this.handleGetParams(
              params,
              'add_sub_work_type_ids',
              subWorkAddNew
            );
          } else {
            params = this.handleGetParams(
              params,
              'delete_main_work_type_ids',
              mainWork.id
            );
            const subWorkUsed = _.without(
              _.map(rootMainWork.sub_work_types, subWork => {
                const isDelete = subWork.using_flag && subWork.id;
                if (isDelete) {
                  listWorkDelete = this.handleListWorkDelete(
                    listWorkDelete,
                    rootMainWork,
                    subWork
                  );
                }
                return isDelete;
              }),
              false
            );
            if (_.isEmpty(subWorkUsed)) {
              listWorkDelete = this.handleListWorkDelete(
                listWorkDelete,
                rootMainWork
              );
            }
            params = this.handleGetParams(
              params,
              'delete_sub_work_type_ids',
              subWorkUsed
            );
          }
        } else {
          if (mainWork.using_flag) {
            const rootSubWorkObj = _.mapValues(
              _.keyBy(rootMainWork.sub_work_types, 'id')
            );
            _.forEach(mainWork.sub_work_types, subWork => {
              if (
                subWork.using_flag !== rootSubWorkObj[subWork.id]['using_flag']
              ) {
                if (subWork.using_flag) {
                  params = this.handleGetParams(
                    params,
                    'add_sub_work_type_ids',
                    subWork.id
                  );
                } else {
                  params = this.handleGetParams(
                    params,
                    'delete_sub_work_type_ids',
                    subWork.id
                  );
                  listWorkDelete = this.handleListWorkDelete(
                    listWorkDelete,
                    rootMainWork,
                    subWork
                  );
                }
              }
            });
          }
        }
      });
    }

    if (!_.isEmpty(listMainWorkAddNew)) {
      _.forEach(listMainWorkAddNew, mainWork => {
        if (mainWork.using_flag) {
          const subWorkUsed = _.without(
            _.map(
              mainWork.sub_work_types,
              subWork => subWork.using_flag && subWork.id
            ),
            false
          );
          params = this.handleGetParams(
            params,
            'add_main_work_type_ids',
            mainWork.id
          );
          params = this.handleGetParams(
            params,
            'add_sub_work_type_ids',
            subWorkUsed
          );
        }
      });
    }
    this.setState({ params, listWorkDelete });
    return new Promise(resolve => {
      resolve(listWorkDelete);
    });
  };

  handleConfirmUpdate = async () => {
    const listWorkDelete = await this.handleParam();
    if (_.isEmpty(listWorkDelete)) {
      return this.updateFieldWorkTypes();
    }
    this.handleVisibleDialog('isShowConfirmDialog', true);
  };

  handleVisibleDialog = (name, visible) => {
    this.setState({
      [name]: visible,
    });
  };

  handleSearch = () => {
    this.searchButtonRef.current.disabled = true;

    const usedTemplateIds = _.difference(
      this.state.tempAllUsedTemplateIds,
      this.state.defaultTemplateIds
    );
    const deleteUsedTemplateIds = _.difference(
      this.state.defaultTemplateIds,
      this.state.tempAllUsedTemplateIds
    );
    this.setState(
      {
        allUsedTemplateIds: this.state.tempAllUsedTemplateIds,
      },
      () => {
        this.getListMainWorkTypes(
          _.isEmpty(usedTemplateIds) ? [''] : usedTemplateIds,
          deleteUsedTemplateIds
        );
      },
    );
  };

  render() {
    const {
      listMainWorkTypes,
      visibleDialogName,
      allUsedTemplateIds,
      tempAllUsedTemplateIds,
      mainWorkId,
      listWorkDelete,
      isShowConfirmDialog,
      isShowPopupError,
      isShowDialogUpdate,
      messageError,
    } = this.state;
    const selectedMainWorkTypes =
      !_.isEmpty(listMainWorkTypes) &&
      _.filter(listMainWorkTypes, mainWork => {
        return mainWork.using_flag === true;
      });
    return (
      <div className='master-slide-view show ProgressSelectWorkType'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{TITLE_BROWSER_PROGRESS.progressSelectWork}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={HEADER_CONSTANTS_PROGRESS.progressSelectWork}
            disableHelpMenu
          />
          <div className='master-slide-view__table fixed-scroller-header'>
            <HeaderMenu
              confirmUpdate={this.handleConfirmUpdate}
              isExistBtnBack={false}
              isDisabledUpdate={
                _.isEmpty(listMainWorkTypes) || _.isEmpty(selectedMainWorkTypes)
              }
            />
            <div className='ProgressSelectWorkType--description'>
              <Description>
                <span>
                  現場で使用する工種にチェックをつけてください。ここでチェックした工種のみが調整会議の作業予定・実績に表示されます。
                </span>
                <br />
                <span>
                  工種のうち、「その他」は自動的に作成され、削除することはできません。
                </span>
              </Description>
            </div>
            <div className='ProgressSelectWorkType__template'>
              <div className='ProgressSelectWorkType__template-title'>
                テンプレート選択
              </div>
              <ProgressTemplateSelector
                label='テンプレートを選択'
                selectedValues={tempAllUsedTemplateIds}
                api={param =>
                  ProgressService.getProgressListWorkTypeTemplates(
                    SessionStorageService.getFieldId(),
                    {
                      ...param,
                    }
                  )
                }
                apiParams={{
                  limit: REQUEST_PARAMS.parentLimit,
                }}
                apiSearchKey='name'
                apiBindDataKey='work_type_templates'
                disableName='work_registered_flag'
                onSelect={values => {
                  this.setTemplateIds(values);
                }}
                multiple={true}
                dropdownSelectStyle={{ width: '234px' }}
                getDefaultTemplateIds={this.getDefaultTemplateIds}
              />
              <button
                className='btn-fixedsize--stay search-form__btn'
                onClick={this.handleSearch}
                ref={this.searchButtonRef}
              >
                検索
              </button>
            </div>
            <div className='master-slide-view__body'>
              <ListSelectMainWork
                listMainWorkTypes={listMainWorkTypes}
                selectMainWork={this.selectMainWork}
                setMainWorkId={this.setMainWorkId}
                templateIds={allUsedTemplateIds}
              />
              <Information
                rootClassName='ProgressSelectWorkTypeDialog'
                visible={visibleDialogName}
                message={
                  <ListSelectSubWork
                    listMainWorkTypes={listMainWorkTypes}
                    mainWorkId={mainWorkId}
                    selectSubWork={this.selectSubWork}
                  />
                }
                title='小工種を選択'
                multilineText={true}
                buttonText='決定'
                buttonClassName='btn'
                onClose={() =>
                  this.handleVisibleDialog('visibleDialogName', false)
                }
              />
              <ProgressConfirmDialog
                listWorkDelete={listWorkDelete}
                visible={isShowConfirmDialog}
                onCancel={() =>
                  this.handleVisibleDialog('isShowConfirmDialog', false)
                }
                onConfirm={this.updateFieldWorkTypes}
              />
              <Information
                visible={isShowPopupError}
                message={messageError}
                title={messageUtility.getMessage('E-001-402')}
                multilineText={true}
                buttonText={messageUtility.getMessage('I-000-137')}
                onClose={() => window.location.reload()}
              />
              <Information
                visible={isShowDialogUpdate}
                message={'使用工種の選択が更新されました。'}
                title={' 更新完了'}
                multilineText={true}
                buttonText={messageUtility.getMessage('I-000-017')}
                onClose={() => {
                  this.rootListMainWorkTypes = listMainWorkTypes;
                  this.handleVisibleDialog('isShowDialogUpdate', false);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ListSelectMainWork = ({
  listMainWorkTypes,
  selectMainWork,
  setMainWorkId,
  templateIds,
}) => {
  const columnHeaders = ['使用', '大工種', '小工種', 'テンプレート'];
  const sortListMainWorkTypes = _.isEmpty(listMainWorkTypes)
    ? []
    : _.sortBy(listMainWorkTypes, ['template.order_number', 'order_number']);

  const renderNoData = () => {
    const isNodata = _.isEmpty(templateIds) || _.isEmpty(templateIds[0]);
    return (
      isNodata && (
        <div className='table__message table-main-work__no-data'>
          テンプレートが選択されていません。
        </div>
      )
    );
  };
  return (
    <React.Fragment>
      <table className='table table-main-work'>
        <RowHeader columnHeaders={columnHeaders} />
        <tbody>
          {_.map(sortListMainWorkTypes, mainWork => {
            const {
              id,
              name,
              using_flag,
              work_registered_flag,
              sub_work_types,
              template,
            } = mainWork;
            const sortListSubWorkTypes = _.isEmpty(sub_work_types)
              ? []
              : _.sortBy(sub_work_types, ['order_number']);
            const listUsedSubWork = _.filter(sortListSubWorkTypes, subWork => {
              return subWork.using_flag;
            });
            const listSubWork =
              !_.isEmpty(sub_work_types) &&
              _.map(listUsedSubWork, item => {
                if (_.size(listUsedSubWork) < 2) {
                  return item.name;
                } else {
                  return _.indexOf(listUsedSubWork, item) ===
                    _.size(listUsedSubWork) - 1
                    ? item.name
                    : `${item.name},`;
                }
              });
            return (
              <tr className='table__item' key={`field_item_list_${id}`}>
                <td
                  className='value-table'
                  onClick={() => selectMainWork(id, work_registered_flag)}
                >
                  <InputCheckBox
                    id={`main-${id}`}
                    name={name}
                    used={using_flag}
                    disabled={work_registered_flag}
                    selectItem={() => selectMainWork(id, work_registered_flag)}
                  />
                </td>
                <td
                  className='value-table'
                  onClick={() => selectMainWork(id, work_registered_flag)}
                >
                  <ToolTip content={name} value={name} />
                </td>
                <td className='value-table'>
                  {using_flag && (
                    <div className='value-table__subwork'>
                      <button
                        className={
                          _.isEmpty(sub_work_types)
                            ? 'btn btn--disabled'
                            : 'btn'
                        }
                        onClick={() => {
                          !_.isEmpty(sub_work_types) && setMainWorkId(id);
                        }}
                        disabled={_.isEmpty(sub_work_types)}
                      >
                        {_.isEmpty(sub_work_types) ? (
                          <ToolTip
                            content='小工種がありません。'
                            value='小工種を選択'
                          />
                        ) : (
                          '小工種を選択'
                        )}
                      </button>
                      <div className='list-sub'>
                        <ToolTip content={listSubWork} value={listSubWork} />
                      </div>
                    </div>
                  )}
                </td>
                <td className='value-table'>
                  <ToolTip content={template.name} value={template.name} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {renderNoData()}
    </React.Fragment>
  );
};

const ListSelectSubWork = ({
  listMainWorkTypes,
  mainWorkId,
  selectSubWork,
}) => {
  const wrapperTable = useRef();
  const table = useRef();

  useEffect(
    () => {
      setStyleTable();
    },
    [listMainWorkTypes]
  );
  const mainWorkTypeItem = _.find(listMainWorkTypes, item => {
    return item.id === mainWorkId;
  });

  const sortListSubWorkTypes = _.isEmpty(mainWorkTypeItem.sub_work_types)
    ? []
    : _.sortBy(mainWorkTypeItem.sub_work_types, ['order_number']);

  const setStyleTable = () => {
    const heightWrapperTable = wrapperTable.current.offsetHeight;
    const heightTable = table.current.offsetHeight;
    if (heightTable > heightWrapperTable) {
      table.current.classList.add('table-scroll');
    }
  };

  const columnHeaders = ['使用', '小工種'];
  return (
    <div>
      <div className='ProgressSelectWorkTypeDialog__title'>
        <span className='ProgressSelectWorkTypeDialog__title-text'>
          テンプレート：{mainWorkTypeItem.template.name}
        </span>
        <span className='ProgressSelectWorkTypeDialog__title-text'>
          大工種：{mainWorkTypeItem.name}
        </span>
      </div>
      <div className='ProgressSelectWorkTypeDialog__table' ref={wrapperTable}>
        <table className='table table-sub-work' ref={table}>
          <RowHeader columnHeaders={columnHeaders} />
          <tbody>
            {sortListSubWorkTypes &&
              _.map(sortListSubWorkTypes, subWork => {
                const { id, name, using_flag, work_registered_flag } = subWork;
                return (
                  <tr
                    className='table__item'
                    key={`field_item_list_${id}`}
                    onClick={() =>
                      selectSubWork(id, mainWorkId, work_registered_flag)
                    }
                  >
                    <td className='value-table'>
                      <InputCheckBox
                        id={`sub-${id}`}
                        name={name}
                        used={using_flag}
                        disabled={work_registered_flag}
                        selectItem={() =>
                          selectSubWork(id, mainWorkId, work_registered_flag)
                        }
                      />
                    </td>
                    <td className='value-table'>{name}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/ProgressSelectWorkType.jsx